import { render, staticRenderFns } from "./KingStocksTable.vue?vue&type=template&id=5a8c8aa1"
import script from "./KingStocksTable.vue?vue&type=script&lang=js"
export * from "./KingStocksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports